import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Skeleton } from 'antd';

import { Plans } from './Plans';
import { TableDescription } from '../../../components/TableDescription';


import { SecureGet } from '../../../services/axiosCall';
import apis from '../../../services/Apis';

import { formRules } from '../../../const/formRules';




const Planing = () => {

  const { state  } = useLocation();
 

  const [loading, setLoading] = useState(false);
  const handleLoading = (loading) => setLoading(loading);

  const [apaShortDes, setApaShortDes] = useState(null);
  const {
    form_no: formNo,
    form_name: formName,
    max_point: maxPoints
  } = apaShortDes || {};
  const handleApaShortDes = (des) => setApaShortDes(des);

  const [apaRules, setApaRules] = useState(null);
  const handleApaRules = (rules) => setApaRules(rules);

  const fetchApaShortDes = (id) => {
    handleApaShortDes(null);
    handleLoading(true);

    SecureGet({ url: `${apis.FORM_LIST}/${id}` })
      .then((response) => {
        handleApaShortDes(response.data);
        handleLoading(false);
      })
      .catch(() => {
        handleLoading(false);
      });
  };

  useEffect(() => {
    if (state.apa_form) fetchApaShortDes(state.apa_form);
  }, [state]);

  useEffect(() => {
    if (apaShortDes) {
      const _formRules = formRules.find((item) => formNo === item.id);
      const { rules } = _formRules || {};
      handleApaRules(rules);
    }
  }, [apaShortDes]);


  return (
    <div>
      {apaShortDes ? (
        <>
          <TableDescription
            formNo={state.form_no}
            formName={formName}
            maxPoints={maxPoints}
            rules={apaRules}
            cameFrom={"faculty"}
          />
          <br />
          <Plans menu={state}/>
          <br />

        </>
      ) : (
        <Skeleton loading={loading} active />
      )}
    </div>
  );
};

export default Planing;
